import { gql } from "@apollo/client";

export const GET_ALL_AREAS_RECLAMO = gql`
  query allAreasReclamo {
    allAreasReclamo {
        idAreaReclamo
        descripcion
    }
}`;

export const adaptAreasReclamoArray = (areas) =>
structuredClone(areas?.allAreasReclamo)?.
map((area) => ({
  id: area?.idAreaReclamo,
  displayName: area?.descripcion
}));